import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Layout from './Layout';
import { getItem } from '../../config/localStorage';

function PrivateRoute() {

    const isLoggedIn = getItem('token');

    if(!isLoggedIn){
        localStorage.clear();
        
    }

    return  !!isLoggedIn ? <Layout ><Outlet /></Layout> : <Navigate to='/home' />
}

export default PrivateRoute